module.exports = __webpack_public_path__ + "static/media/howItWork2.6a717638.png";